export default __webpack_public_path__ + "static/media/cube.32595039.svg";